// extracted by mini-css-extract-plugin
module.exports = {"title":"title__AeL8_","form":"form__J5pDm","textarea":"textarea__UZbZe","modal":"modal__On7eq"};